import { graphql, useStaticQuery } from 'gatsby';
import PropTypes from 'prop-types';
import React from 'react';

import DropDown from '../Common/DropDown';
import * as styles from './ResourceFilters.module.css';

const organizeOptions = (labels = [''], values = ['']) => {
  let options = [];
  labels.forEach((label) => {
    const lower = label
      .toLowerCase()
      .replace(/\s+&\s+/g, '-')
      .replace(/\s+/g, '-');
    let value = values.find((v) => v === lower);

    if (!value) return;
    options.push({ label, value });
  });
  return options;
};

const ResourceFilters = ({ location }) => {
  const data = useStaticQuery(graphql`
    {
      allContentfulRoleType {
        titles: distinct(field: title)
      }
      allContentfulRoleType {
        slugs: distinct(field: slug)
      }
      allContentfulIndustryType {
        titles: distinct(field: title)
      }
      allContentfulIndustryType {
        slugs: distinct(field: slug)
      }
      allContentfulContentType {
        titles: distinct(field: title)
      }
      allContentfulContentType {
        slugs: distinct(field: slug)
      }
    }
  `);

  return <ResourceFiltersRender data={data} location={location} />;
};

class ResourceFiltersRender extends React.Component {
  constructor(props) {
    super(props);

    //build options
    const { data, location } = props;
    const roleOptions = organizeOptions(data.allContentfulRoleType.titles, data.allContentfulRoleType.slugs);
    const industryOptions = organizeOptions(
      data.allContentfulIndustryType.titles,
      data.allContentfulIndustryType.slugs
    );
    const contentOptions = organizeOptions(data.allContentfulContentType.titles, data.allContentfulContentType.slugs);

    const locationPath = location?.pathname?.split('/').filter((p) => p !== '');
    const hasValue = locationPath.length > 1;
    const edge = hasValue && locationPath[1];
    const filter = hasValue && locationPath[2];
    let selectedOption;
    if (hasValue) {
      const options = {
        roles: roleOptions,
        industries: industryOptions,
        content: contentOptions,
      };
      selectedOption = options[edge]?.find((f) => f.value === filter);
    }

    this.state = {
      roleOptions,
      industryOptions,
      contentOptions,
      selectedOption,
      edge,
    };
  }

  render() {
    const filter = (type, selection) => {
      if (typeof window === 'undefined') return;
      if (!selection) {
        return (window.location = '/resources/');
      }
      window.location = `/resources/${type}/${selection.value}`;
    };
    const { edge } = this.state;
    return (
      <div className={styles.filters}>
        <DropDown
          aria-label={'Filter by Role'}
          placeholder={'Filter by Role'}
          options={this.state.roleOptions}
          noOptionsMessage={() => 'Select Role'}
          isSearchable={false}
          isClearable={true}
          onChange={(option) => filter('roles', option)}
          value={edge === 'roles' && this.state.selectedOption}
        />
        <DropDown
          aria-label={'Filter by Industry'}
          placeholder={'Filter by Industry'}
          options={this.state.industryOptions}
          noOptionsMessage={() => 'Select Industry'}
          isSearchable={false}
          isClearable={true}
          onChange={(option) => filter('industries', option)}
          value={edge === 'industries' && this.state.selectedOption}
        />
        <DropDown
          aria-label={'Filter by Type'}
          placeholder={'Filter by Type'}
          options={this.state.contentOptions}
          isClearable={true}
          noOptionsMessage={() => 'Select Type'}
          isSearchable={false}
          onChange={(option) => filter('content', option)}
          value={edge === 'content' && this.state.selectedOption}
        />
      </div>
    );
  }
}

ResourceFilters.propTypes = {
  filterType: PropTypes.string,
  filterSelected: PropTypes.string,
};

export default ResourceFilters;
